var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import { LitElement, noChange } from "lit";
import { fetchApiData, stringDecoder, numberDecoder, customElement, PICSuggestion } from '../../Internals';
let PICOptionGroup = class PICOptionGroup extends LitElement {
    constructor() {
        super();
        this.minChars_ = 0;
        this.componentRef = null;
        this.hasValSubOption = false;
        this.skipParsing = false;
        this.options = new Map();
        this.reqHist = [];
    }
    set parentData(iData) {
        this.componentRef = iData.ref;
    }
    get data() {
        let res = [];
        this.options.forEach((v, k) => {
            res.push(v);
        });
        return res;
    }
    async optHandler(preventSelection) {
        if (this.componentRef) {
            await this.componentRef.updateComplete;
            // TODO look at this when you don't hate your life 
            setTimeout(() => { childConsumer(this); }, 50);
            function childConsumer(iOptHandler) {
                for (let child of iOptHandler.children) {
                    if (child.tagName == 'DATA') {
                        let tmp = {
                            key: decodeValue(child, 'key'),
                            val: decodeValue(child, 'val')
                        };
                        if (child.hasAttribute('valsub')) {
                            tmp.valsub = decodeValue(child, 'valsub');
                            iOptHandler.hasValSubOption = true;
                        }
                        if (child.hasAttribute('action')) {
                            // console.log(child, child.getAttribute('action'), (child as any).action);
                            if (typeof child.getAttribute('action') == 'string' || child.getAttribute('action') instanceof String)
                                tmp.action = JSON.parse(decodeValue(child, 'action'));
                            else
                                tmp.action = child.getAttribute('action');
                        }
                        iOptHandler.options.set(tmp.key, tmp);
                    }
                }
                if (iOptHandler.progpath_) {
                    iOptHandler.getAndParseOptions(false, false, undefined, preventSelection);
                }
                if (preventSelection) {
                    iOptHandler.dispatchEvent(new CustomEvent('DataParsed', { detail: { preventSelection: preventSelection }, bubbles: true, composed: true }));
                }
                else {
                    iOptHandler.dispatchEvent(new CustomEvent('DataParsed', { detail: iOptHandler.data, bubbles: true, composed: true }));
                }
                if (iOptHandler.componentRef instanceof PICSuggestion) {
                    iOptHandler.componentRef.findSuggestions();
                    iOptHandler.componentRef.dataReady(preventSelection);
                }
                iOptHandler.componentRef.requestUpdate();
            }
        }
    }
    getAndParseOptions(clear, triggeredFromOther, iValue, preventSelection) {
        if (this.skipParsing)
            return;
        let parm = this.parms_ || '';
        let pp = this.progpath_;
        if (iValue || this.parms_ == 'onchange' || (this.parms_ && this.parms_.startsWith('onchange\x03'))) {
            if (iValue) {
                parm = iValue.key;
            }
            else {
                if (this.componentRef) {
                    //submitValue can be undefined therefore reference inputfield value directly
                    parm = this.componentRef.inputField.value;
                    if (!parm)
                        parm = '';
                }
                //save searched terms to prevent multifire
                /*if(this.ppmasterExec == 'notfired' && parm.length == 0 && this.masterpp_){
                    pp = this.masterpp_;
                    this.ppmasterExec = 'fired';
                }*/
                if (this.reqHist.includes(parm) || parm.length == 0) {
                    // console.log('already searched for ', parm)
                    return;
                }
                else {
                    // console.log('searcing for ', parm)
                    this.reqHist.push(parm);
                }
            }
        }
        if (parm.length >= this.minChars_) {
            //Add parms to onchange event, after minChar check (the \x03 is when using begins + parms)
            if (this.parms_ && this.parms_.startsWith('onchange\x03')) {
                parm += '\x03' + this.parms_.substring(9);
            }
            let tmp = {
                postBody: {
                    mode: 'getOptions',
                    data: {
                        progPath: pp,
                        parms: parm
                    }
                }
            };
            let ref = this;
            if (clear) {
                ref.options.clear();
            }
            return fetchApiData('incl/optionsapi', tmp).then((data) => {
                data.forEach((opt) => {
                    if (!('val' in opt))
                        opt.val = opt.key;
                    ref.options.set(opt.key, opt);
                    if (opt.valsub)
                        ref.hasValSubOption = true;
                });
                if (ref.componentRef) {
                    if (ref.componentRef instanceof PICSuggestion) {
                        //if(PIC.getInstance.webVersion == '2.5'){
                        if (ref.componentRef.getAttribute('value') != ref.componentRef.value && ref.componentRef.value) {
                            ref.componentRef.findSuggestions(new Event(''));
                        }
                        else if (triggeredFromOther) {
                            ref.componentRef.findSuggestions(new Event(''));
                        }
                        ref.componentRef.dataReady(preventSelection);
                        /*} else if(triggeredFromOther) {
                            ref.componentRef._selectOption({option:Array.from(ref.componentRef.optionContainer.options)[0][1]})
                        }*/
                    }
                    ref.componentRef.requestUpdate();
                }
            });
        }
    }
    isValInOptions(iVal) {
        if (this.options.get(iVal))
            return 'key';
        for (let [key, value] of this.options.entries()) {
            if (value.val === iVal)
                return 'val';
            if (value.val.toLocaleUpperCase() === iVal.toLocaleUpperCase())
                return 'val';
            if (value.key.toLocaleUpperCase() === iVal.toLocaleUpperCase())
                return 'key';
        }
        return 'not';
    }
    getKeyfromOptions(iVal) {
        for (let [key, value] of this.options.entries()) {
            if (value.val === iVal)
                return key;
            if (value.val.toLocaleUpperCase() === iVal.toLocaleUpperCase())
                return key;
        }
        return '';
    }
    getValFromOptions(iKey) {
        let tmp = this.options.get(iKey);
        if (tmp)
            return tmp.val;
        return '';
    }
    getOption(iKey) {
        for (let [key, value] of this.options.entries()) {
            if (key.toLocaleUpperCase() === iKey.toLocaleUpperCase())
                return value;
        }
        return this.options.get(iKey);
    }
    getLengthOfLongestValue() {
        let longest = -Infinity;
        for (let [key, value] of this.options.entries()) {
            // if(value.valsub){
            //     if(value.valsub.length > longest) longest = value.valsub.length;
            //     if(value.val.length > longest) longest = value.val.length;
            // } else {
            if (value.val.length > longest)
                longest = value.val.length;
            // }
        }
        return longest;
    }
    /** inefficient search but will work */
    searchValInOptionsIndex(iSearch, iIdx) {
        for (let i = 0; i < this.data.length; i++) {
            if (this.data[i].val.toLocaleLowerCase().startsWith(iSearch.toLocaleLowerCase())) {
                return i;
            }
        }
        return iIdx;
    }
    addOption(iOpt) {
        this.options.set(iOpt.key, iOpt);
        this.componentRef.requestUpdate();
    }
    addOptionArray(iOptions) {
        iOptions.forEach(opt => {
            this.options.set(opt.key, opt);
        });
        this.componentRef.requestUpdate();
    }
    removeOption(iOpt) {
        if (this.options.has(iOpt.key)) {
            this.options.delete(iOpt.key);
            this.componentRef.requestUpdate();
        }
    }
    /** For use when swapping out all options with an update-command */
    swapOptions(iOptions, mc, pp, p) {
        this.minChars_ = mc;
        this.progpath_ = pp;
        this.parms_ = p;
        if (iOptions.length > 0) {
            this.options.clear();
            this.addOptionArray(iOptions);
        }
        if (pp.length > 0)
            this.getAndParseOptions(true, false);
    }
    render() {
        return noChange;
    }
};
__decorate([
    property({ converter: stringDecoder, attribute: 'progpath' })
], PICOptionGroup.prototype, "progpath_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'parms' })
], PICOptionGroup.prototype, "parms_", void 0);
__decorate([
    property({ converter: numberDecoder, attribute: 'minchars' })
], PICOptionGroup.prototype, "minChars_", void 0);
PICOptionGroup = __decorate([
    customElement('pic-optiongroup')
], PICOptionGroup);
export { PICOptionGroup };
function decodeValue(iElement, propKey) {
    let retVal;
    try {
        retVal = decodeURIComponent(iElement.getAttribute(propKey));
        if (retVal == 'null' && ['key', 'val'].includes(propKey)) {
            retVal = '';
        }
    }
    catch (error) {
        retVal = iElement.getAttribute(propKey);
    }
    return retVal;
}
//# sourceMappingURL=PICOptionGroup.js.map